import React from "react";
import Documents from "../../components/Documents/Documents";

const DocumentPage = () => {
  return <Documents />;
};

export default DocumentPage;
